import { Link } from "react-router-dom";

import { useLanguage } from "@/i18n/LanguageContext";
import { AuthenticatedShell, type ShellNavItem } from "./AuthenticatedShell";

export function AdminShell() {
  const { t } = useLanguage();
  const items: ShellNavItem[] = [
    { to: "/admin", label: t.nav.adminOverview, end: true },
    { to: "/admin/registrations", label: t.nav.adminRegistrations },
    { to: "/admin/reviewers", label: t.nav.adminReviewers },
    { to: "/admin/papers", label: t.nav.adminPapers },
    { to: "/admin/past-events", label: t.nav.adminPastEvents },
    { to: "/admin/sessions", label: t.nav.adminSessions },
    { to: "/admin/correspondence", label: t.nav.adminCorrespondence },
    { to: "/admin/messages", label: t.nav.adminMessages },
    { to: "/admin/certificates", label: t.nav.adminCertificates },
    { to: "/admin/reminders", label: t.nav.adminReminders },
    { to: "/admin/settings", label: t.nav.adminSettings },
    { to: "/account/security", label: t.nav.accountSecurity },
  ];

  return (
    <AuthenticatedShell
      title={t.brandShort}
      subtitle={t.nav.adminWorkspace}
      homeTo="/admin"
      items={items}
      wide
      footerSlot={
        <Link to="/" className="dn-side-nav-extra">
          {t.nav.viewPublicSite}
        </Link>
      }
    />
  );
}
